import React from 'react';

import { GridBodyProps } from './GridBody/GridBody';
import GridBody from './GridBody';

export type GridProps = GridBodyProps;

const Grid = ({
	tasks,
	dates,
	rowHeight,
	svgWidth,
	columnWidth,
	todayColor,
	setTodayColumnScrollX,
}: GridProps) => {
	return (
		<g className='grid'>
			<GridBody
				columnWidth={columnWidth}
				dates={dates}
				rowHeight={rowHeight}
				setTodayColumnScrollX={setTodayColumnScrollX}
				svgWidth={svgWidth}
				tasks={tasks}
				todayColor={todayColor}
			/>
		</g>
	);
};

export default Grid;
